import { render, staticRenderFns } from "./ListShipments.vue?vue&type=template&id=7ea6325e"
import script from "./ListShipments.vue?vue&type=script&lang=js"
export * from "./ListShipments.vue?vue&type=script&lang=js"
import style0 from "./ListShipments.vue?vue&type=style&index=0&id=7ea6325e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports